export default "__VITE_PUBLIC_ASSET__81a4319b__"